import React, { useState } from "react";

/** Free-text chips (e.g. KPIs): type and press Enter; Backspace on empty removes the last one. */
const ChipsInput = ({ value, onChange, placeholder, id, readOnly }) => {
  const [draft, setDraft] = useState("");

  const add = () => {
    const text = draft.trim();
    if (text && !value.includes(text)) onChange([...value, text]);
    setDraft("");
  };

  return (
    <div className="chips-input">
      {value.map((chip) => (
        <span key={chip} className="chip">
          {chip}
          {!readOnly && (
            <button
              type="button"
              className="chip-remove"
              onClick={() => onChange(value.filter((c) => c !== chip))}
              aria-label={`Remove ${chip}`}
            >
              <i className="bi bi-x"></i>
            </button>
          )}
        </span>
      ))}
      {!readOnly && (
        <input
          id={id}
          className="chips-input-field"
          value={draft}
          placeholder={value.length ? "" : placeholder}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === ",") {
              e.preventDefault();
              add();
            } else if (e.key === "Backspace" && !draft && value.length) {
              onChange(value.slice(0, -1));
            }
          }}
          onBlur={add}
        />
      )}
    </div>
  );
};

export default ChipsInput;
